import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { isOnboardingComplete, ONBOARDING_HOME_PATH } from '../../utils/onboardingPersistence';

/**
 * Redirects incomplete onboarding users to /welcome.
 * /welcome redirects to Setups when already complete (unless ?replay=1).
 */
export default function OnboardingGuard({ children }) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { userId, pilotWhitelisted, isAdmin } = useAuth();

  const isAuthenticated = Boolean(userId);
  const canUseApp = pilotWhitelisted || (isAdmin && isAdmin());
  const complete = isOnboardingComplete();
  const isWelcome = location.pathname === '/welcome';
  const isReplay = searchParams.get('replay') === '1';

  if (!isAuthenticated || !canUseApp) {
    return children;
  }

  if (isWelcome) {
    if (complete && !isReplay) {
      return <Navigate to={ONBOARDING_HOME_PATH} replace />;
    }
    return children;
  }

  if (!complete) {
    return <Navigate to="/welcome" replace state={{ from: location.pathname }} />;
  }

  return children;
}
